import React, { useState, useEffect } from "react";
import { app } from "../firebase";
import { getFirestore, collection, addDoc, serverTimestamp, query, where, getDocs } from "firebase/firestore";
import "./contact.css";
import { Modal, Button } from "react-bootstrap";
import { getAuth } from "firebase/auth";
import emailjs from 'emailjs-com';


const Contact = ({ isDarkMode, toggleTheme }) => {
    const [name, setName] = useState("");
    const [message, setMessage] = useState("");
    const [loader, setLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [email, setEmail] = useState("");

    const db = getFirestore(app);
    const auth = getAuth(app);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Form validation
        if (!name || !email || !message) {
            setErrorMessage("Please fill in all fields");
            return;
        }

        // Email validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            setErrorMessage("Please enter a valid email address");
            return;
        }

        // Check message length
        if (message.split(" ").length > 250) {
            setErrorMessage("Message should not exceed 250 words");
            return;
        }

        // Check message limit per hour
        const currentTime = new Date();
        const lastHour = new Date();
        lastHour.setHours(lastHour.getHours() - 1);

        const userRef = collection(db, "contacts");
        const q = query(
            userRef,
            where("email", "==", email),
            where("timestamp", ">", lastHour)
        );

        const querySnapshot = await getDocs(q);
        if (querySnapshot.size >= 3) {
            setErrorMessage("You have reached the maximum limit of messages per hour.");
            return;
        }

        setLoader(true);

        try {
            const docRef = await addDoc(collection(db, "contacts"), {
                name: name,
                email: email,
                message: message,
                timestamp: serverTimestamp(), // Add timestamp to track message time
            });

            // Send email to admin
            emailjs.send("service_16wb5hx", "template_0aik25i", {
                name: name,
                email: email,
                message: message,
            }, "R3KoRl6-uisEa05rl")
                .then((response) => {
                    console.log('Email sent to admin:', response);
                })
                .catch((error) => {
                    console.error('Error sending email:', error);
                });

            setLoader(false);
            setShowModal(true);
            console.log("Document written with ID: ", docRef.id); // Log the document ID to console
            console.log("Message sent by email:", { name, email, message }); // Log message details
        } catch (error) {
            setErrorMessage(error.message);
            setLoader(false);
        }

        setName("");
        setEmail(""); // Do not clear email here
        setMessage("");
    };

    const MAX_CHARACTERS = 250;

    const handleChange = (e) => {
        const value = e.target.value;

        if (value.length <= MAX_CHARACTERS) {
            setMessage(value);
        } else {
            setMessage(value.slice(0, MAX_CHARACTERS));
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleCloseError = () => {
        setErrorMessage("");
    };

    useEffect(() => {
        const user = auth.currentUser;
        if (user) {
            setEmail(user.email);
        }
    }, [auth]);
    return (
        <div
            className={`container ${
                isDarkMode ? "dark-mode" : "light-mode"
            }`}
            style={{
                backgroundColor: isDarkMode ? "#333" : "#f8f9fa",
                minHeight: "100vh",
            }}
        >
            <div className="row justify-content-center mt-5">
                <div className="col-md-8 col-lg-6 col-sm-12">
                    <div
                        className="card"
                        style={{
                            backgroundColor: isDarkMode ? "#333" : "#f8f9fa",
                            marginTop: "-3%",
                            marginLeft: "6%",
                        }}
                    >
                        <div className="card-body">
                            <h5 className="card-title text-center">Reach Us</h5>
                            {errorMessage && (
                                <div
                                    className="alert alert-danger"
                                    role="alert"
                                >
                                    {errorMessage}
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={handleCloseError}
                                    ></button>
                                </div>
                            )}
                            <form>
                                <div className="mb-3">
                                    <input
                                        placeholder="Name"
                                        type="text"
                                        name="name"
                                        className={`form-control ${
                                            isDarkMode
                                                ? ""
                                                : "placeholder-color"
                                        }`}
                                        value={name}
                                        onChange={(e) =>
                                            setName(e.target.value)
                                        }
                                        style={{
                                            backgroundColor: isDarkMode
                                                ? "#f8f9fa"
                                                : "#333",
                                            color: isDarkMode
                                                ? "#000"
                                                : "#fff",
                                        }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <input
                                        placeholder="Email"
                                        type="text"
                                        name="email"
                                        className={`form-control ${
                                            isDarkMode
                                                ? ""
                                                : "placeholder-color"
                                        }`}
                                        value={email}
                                        disabled
                                        style={{
                                            backgroundColor: isDarkMode
                                                ? "#f8f9fa"
                                                : "#333",
                                            color: isDarkMode
                                                ? "#000"
                                                : "#fff",
                                        }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <textarea
                                        placeholder="Say Hello"
                                        rows="8"
                                        className={`form-control ${
                                            isDarkMode
                                                ? ""
                                                : "placeholder-color"
                                        }`}
                                        name="message"
                                        value={message}
                                        onChange={handleChange}
                                        style={{
                                            backgroundColor: isDarkMode
                                                ? "#f8f9fa"
                                                : "#333",
                                            color: isDarkMode
                                                ? "#000"
                                                : "#fff",
                                        }}
                                    ></textarea>
                                </div>

                                <div className="mb-3">
                                    <button
                                        type="submit"
                                        className="btn btn-white"
                                        onClick={handleSubmit}
                                        style={{
                                            backgroundColor: isDarkMode
                                                ? "white"
                                                : "#333",
                                            color: isDarkMode
                                                ? "#333"
                                                : "white",
                                            width: "100%",
                                            marginLeft:"2%"
                                        }}
                                    >
                                        Send
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* Success Modal */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>Your message has been submitted 👍</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Contact;
